import { X } from "lucide-react";
import { useEffect, type ReactNode } from "react";
import useTranslation from "../../client/hooks/useTranslation";
import { useHideSupportLauncher } from "./useHideSupportLauncher";

/** Panneau latéral générique du Lite : même gabarit que le TradeDrawer, contenu libre. */
export function LiteDrawer({ open, title, subtitle, onClose, children, footer }: {
  open: boolean;
  title: string;
  subtitle?: ReactNode;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}) {
  const t = useTranslation().lite;
  useHideSupportLauncher(open);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <aside className="absolute right-0 top-0 h-full w-full max-w-[440px] bg-card border-l border-border shadow-2xl flex flex-col animate-in slide-in-from-right duration-200" role="dialog" aria-label={title}>
        <header className="flex items-start justify-between gap-3 px-6 pt-5 pb-4 border-b border-border">
          <div className="min-w-0">
            <h2 className="font-display text-xl font-bold">{title}</h2>
            {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
          </div>
          <button type="button" onClick={onClose} className="w-9 h-9 grid place-items-center rounded-lg hover:bg-muted text-muted-foreground" aria-label={t.common.close}><X size={18} /></button>
        </header>
        <div className="flex-1 overflow-y-auto px-6 py-5 space-y-5">{children}</div>
        {footer && <footer className="px-6 py-4 border-t border-border flex items-center justify-between gap-3">{footer}</footer>}
      </aside>
    </div>
  );
}
